import { jobApplications } from '../../services/apiService';
import HistoryTab from '../UI/HistoryTab';

/**
 * Компонент для отображения истории событий Job Application
 * Использует общий компонент HistoryTab
 */
const EventsTab = ({ applicationId }) => {
  return (
    <HistoryTab
      entityId={applicationId}
      fetchEventsFunction={jobApplications.getJobApplicationEvents}
      fetchStatsFunction={jobApplications.getJobApplicationEventStats}
    />
  );
};

export default EventsTab;
